export default __webpack_public_path__ + "static/media/Connected-Accounts.44e98b3a.png";